<form #attendanceForm="ngForm" (ngSubmit)="submitAttendance(attendanceForm)" class="class-container">
  <div class="box-one">

    <div class="summary">

      <h6 class="lighter-color">SUMMARY</h6>

      <div class="attendance-summary">
        <div><h6 class="lighter-color">Total Students</h6></div>
        <div><p class="red-color">{{ totalStudents() }}</p></div>
      </div>

      <div class="attendance-summary">
        <div><h6 class="lighter-color">Marked</h6></div>
        <div><p class="blue-color">{{ markedCount() }}</p></div>
      </div>

      <div class="attendance-summary">
        <div><h6 class="lighter-color">Present</h6></div>
        <div><p class="green-color">{{ presentCount() }}</p></div>
      </div>

      <div class="attendance-summary">
        <div><h6 class="lighter-color">Absent</h6></div>
        <div><p class="red-color">{{ absentCount() }}</p></div>
      </div>

      <div class="pole">
        <div class="green-pole" [style.width.%]="totalStudents() ? (presentCount() / totalStudents()) * 100 : 0"></div>
        <div class="red-pole" [style.width.%]="totalStudents() ? (absentCount() / totalStudents()) * 100 : 0"></div>
      </div>

      <div class="attendance-percent">
        <p class="lighter-color">{{ percentMarked() }}% marked</p>
      </div>
    </div>
    <div class="attendance-data-container">

      <div class="attendance-date">
        <label for="attendanceDate" class="lighter-color">DATE</label>
        <input [max]="todayDate" required type="date" name="attendanceDate" [(ngModel)]="attendanceDate" id="attendanceDate">
      </div>

      <div class="attendance-mark">

        <h6 class="lighter-color">MARK ALL AS</h6>

        <div class="green" (click)="markAll('PRESENT', attendanceForm)">
          <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13" fill="none">
            <path d="M10.822 3.24658L4.8699 9.19868L2.1644 6.49318" stroke="#15803D" stroke-width="1.35275" />
          </svg>
          <p>All Present</p>
        </div>

        <div class="red" (click)="markAll('ABSENT', attendanceForm)">
          <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13" fill="none">
            <path d="M9.7398 3.24658L3.2466 9.73978" stroke="#B91C1C" stroke-width="1.35275" />
            <path d="M3.2466 3.24658L9.7398 9.73978" stroke="#B91C1C" stroke-width="1.35275" />
          </svg>
          <p>All Absent</p>
        </div>

      </div>

      <button [disabled]="attendanceForm.invalid" class="button" type="submit">
        @if (isSubmitting()) {
          <app-loading-indicator />
        } @else {
        Save Attendance
        }
      </button>

    </div>

  </div>

  <section class="box-two">
    <div class="attendace-heading"></div>

    <div class="attendance-container">
      <div class="attendance-heads">
        <h4>Student Register</h4>
        <p class="light-color">{{ classStudents()?.payload?.length ?? 0 }} students</p>
      </div>

      @for (student of classStudents()?.payload; track $index) {
        <div class="attendance-list">
          <div class="q">
            <div class="name">
              <p class="light-color">{{ $index + 1 }}</p>
            </div>

            <div class="name-stu-id">
              <p>{{ student.student_last_name }} {{ student.student_first_name }}</p>
              <p class="light-color">{{ student.student_public_id }}</p>
            </div>
          </div>

          <div class="attendance-status">
            <div class="radio">
              <input required type="radio" [id]="'present-' + $index" [name]="'status' + $index" value="PRESENT" ngModel>
              <label [for]="'present-' + $index">Present</label>
            </div>

            <div class="radio">
              <input required type="radio" [id]="'absent-' + $index" [name]="'status' + $index" value="ABSENT" ngModel>
              <label [for]="'absent-' + $index">Absent</label>
            </div>
          </div>
        </div>
      }
    </div>
  </section>
</form>

